var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "promptChangedDialog",
      attrs: {
        visible: _vm.promptShow,
        width: "430px",
        "close-on-click-modal": false,
        "show-close": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.promptShow = $event
        },
      },
    },
    [
      _c("span", { staticClass: "promptTip" }, [
        _vm._v("即将离开当前程序，是否保存？"),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.$emit("cancel")
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("unSaveWork")
                    },
                  },
                },
                [_vm._v("不保存")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("saveWork")
                    },
                  },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/classroom1/components/promptChangedDialog.vue?vue&type=template&id=78389ce6&
// module id = null
// module chunks = 